import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as DataAccessExhibitorsActions from './data-access-exhibitors.actions';
import * as DataAccessExhibitorsSelectors from './data-access-exhibitors.selectors';

@Injectable()
export class DataAccessExhibitorsFacade {
  exhibitor$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitor));
  coExhibitors$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getCoExhibitors));
  parentExhibitor$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getParentExhibitor));
  exhibitorLoading$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorLoading));
  exhibitorError$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorError));
  exhibitorDirectory$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitorDirectory));
  exhibitorProducts$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitorExhibitorProducts));
  exhibitorProductsLoading$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorProductsLoading));
  exhibitorProductsError$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorProductsError));
  exhibitorPosts$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitorExhibitorPosts));
  exhibitorPostsLoading$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorPostsLoading));
  exhibitorPostsError$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorPostsError));
  exhibitorEventsLoading$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorEventsLoading));
  exhibitorEventsError$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getActiveExhibitorEventsError));
  exhibitorContactPerson$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitorContactPerson));
  exhibitorDirectoryStatus$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitorDirectoryStatus));
  exhibitorDirectoryResults$ = this.store.pipe(
    select(DataAccessExhibitorsSelectors.getExhibitorDirectorySearchResults)
  );
  exhibitorDirectoryHallList$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getHallList));
  exhibitorDirectoryLetterList$ = this.store.pipe(select(DataAccessExhibitorsSelectors.getLetterList));

  constructor(private readonly store: Store) {}

  pageOpened(exhibitorId: string, fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorOpened({ exhibitorId, fairId }));
  }

  contactPersonPageOpened(exhibitorId: string, contactPersonIndex: string, fairId: string) {
    this.store.dispatch(
      DataAccessExhibitorsActions.exhibitorContactPersonOpened({
        exhibitorId,
        contactPersonIndex,
        fairId,
      })
    );
  }

  directoryPageOpenedAnywhere(fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorDirectoryOpenedAnywhere({ fairId }));
  }

  directoryPageOpened(letter: string, fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorDirectoryOpened({ letter, fairId }));
  }

  directoryHallsPageOpened(hall: string, fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorDirectoryHallsOpened({ hall, fairId }));
  }

  directorySearchPageOpened(searchTerm: string, fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorDirectorySearchOpened({ searchTerm, fairId }));
  }

  directorySearchLoadNext(searchTerm: string, fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorDirectorySearchLoadNext({ searchTerm, fairId }));
  }

  fairTabOpened(exhibitorId: string, fairId: string) {
    this.store.dispatch(DataAccessExhibitorsActions.exhibitorFairTabOpened({ exhibitorId, fairId }));
  }

  getExhibitorById(exhibitorId?: string) {
    return this.store.pipe(select(DataAccessExhibitorsSelectors.getExhibitorById, { exhibitorId }));
  }

  getExhibitorFromDirectoryById(exhibitorId?: string, startingLetter?: string) {
    return this.store.pipe(
      select(DataAccessExhibitorsSelectors.getExhibitorFromDirectoryById, { exhibitorId, startingLetter })
    );
  }
}
